import React, { useEffect, useImperativeHandle, useState } from "react";
import {
  components,
  SelectInstance,
  IndicatorSeparatorProps,
  MenuListProps,
  CSSObjectWithLabel,
  GroupBase,
} from "react-select";
import CreatableSelect from "react-select/creatable";
import AsyncCreatableSelect from "react-select/async-creatable";
import { useField } from "formik";
import { useFormContext } from "react-hook-form";
// @ts-ignore
import get from "lodash/get";

interface CreatablePropsType {
  id: string;
  className?: string;
  placeholder?: string;
  FieldName: string;
  name?: string;
  options: Array<any>;
  isDisabled?: boolean;
  onCreateOption?: any;
  handleChange: any;
  changeValuePerameter?: any;
  defaultValue?: any;
  onClear?: any;
  onLanguageChange?: any;
  isNotCreatable?: boolean;
  CustomOptionComponent?: any;
  isClearable?: boolean;
  filterOption?: any;
  menuPortalTarget?: any;
  isSearchable?: boolean;
  autoFocus?: boolean;
  optionInnerWidth?: any;
  defaultOptions?: any;
  onBlur?: any;
  tabIndex?: number;
  tabSelectsValue?: boolean;
  openMenuOnFocus?: boolean;
  onFocus?: any;
  getOptionValue?: any;
  getOptionLabel?: any;
  ref?: null;
  value: any;
  Value?: any;
  isMulti?: boolean;
  isIndicatorSeparator?: boolean;
  isBorderNone?: boolean;
  key?: string;
  isPlaceholderFloating?: boolean;
  closeMenuOnSelect?: boolean;
  hideSelectedOptions?: boolean;
  controlShouldRenderValue?: boolean;
  onSelectResetsInput?: boolean;
  backspaceRemovesValue?: boolean;
  createOptionLabel?: string;
  onChange?: any;
}

interface AsyncCreatablePropsType {
  id: string;
  className?: string;
  placeholder?: string;
  FieldName: string;
  name?: string;
  loadOptions?: any;
  isDisabled?: boolean;
  menuPlacement?: any;
  onCreateOption?: any;
  handleChange: any;
  changeValuePerameter?: any;
  onClear?: any;
  isNotCreatable?: boolean;
  CustomOptionComponent?: any;
  CustomSingleValueComponent?: any;
  isClearable?: boolean;
  filterOption?: any;
  menuPortalTarget?: any;
  isSearchable?: boolean;
  noOptionsMessage?: any;
  onInputChange?: any;
  defaultOptions?: any;
  autoFocus?: any;
  optionInnerWidth?: any;
  onBlur?: any;
  tabIndex?: number;
  openMenuOnFocus?: boolean;
  tabSelectsValue?: boolean;
  getOptionValue?: any;
  getOptionLabel?: any;
  onFocus?: any;
  ref?: null;
  isMulti?: boolean;
  value?: any;
  Value?: any;
  options?: Array<any>;
  isIndicatorSeparator?: boolean;
  isBorderNone?: boolean;
  key?: string;
  customMenuList?: any;
  menuIsOpen?: boolean;
  closeMenuOnSelect?: boolean;
  hideSelectedOptions?: boolean;
  controlShouldRenderValue?: boolean;
  onSelectResetsInput?: boolean;
  backspaceRemovesValue?: boolean;
  createOptionLabel?: string;
  styles?: any;
  onChange?: any;
}

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      {/* custom html here for option  */}
      <div> {props.children}</div>
    </components.Option>
  );
};

const ValueContainer = (props: any) => {
  return (
    <components.ValueContainer {...props}>
      {props?.selectProps?.isPlaceholderFloating && (
        <components.Placeholder {...props} isFocused={props.isFocused}>
          {props.selectProps.placeholder}
        </components.Placeholder>
      )}
      {React.Children.map(props.children, (child) => {
        if (
          child?.type === components?.Placeholder &&
          props?.selectProps?.isPlaceholderFloating
        ) {
          return null;
        }
        return child;
      })}
    </components.ValueContainer>
  );
};

// const filterOption = (candidate, input) => {
//   return (
//     candidate.data.__isNew__ ||
//     candidate.label?.toLowerCase().includes(input?.toLowerCase().trim())
//   );
// };

const MenuList = (props: MenuListProps) => {
  return <components.MenuList {...props}>{props.children}</components.MenuList>;
};

const indicatorSeparatorStyle = {
  alignSelf: "stretch",
  backgroundColor: "black",
  marginBottom: 8,
  marginTop: 8,
  width: 1,
};

const IndicatorSeparator = ({ innerProps }: IndicatorSeparatorProps<true>) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

const isIPad =
  navigator.userAgent.includes("iPad") ||
  (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1);

export const CustomSelect = React.forwardRef<
  SelectInstance<any>,
  CreatablePropsType
>((props: CreatablePropsType, ref) => {
  const {
    FieldName,
    options,
    handleChange,
    changeValuePerameter,
    onClear,
    isNotCreatable,
    CustomOptionComponent,
    placeholder,
    onBlur,
    ...restProps
  } = props;

  const methods = useFormContext();
  const error = get(methods?.formState?.errors, FieldName);

  // const [menuLeft, setMenuLeft] = useState<any>(0);
  // const [menuRight, setMenuRight] = useState<any>(0);

  // Use a local ref to access the Select DOM element
  // const internalRef = React.useRef<any>(null);

  // // Expose the internal ref via the forwarded ref
  // useImperativeHandle(ref, () => internalRef.current);

  // const handleMenuOpen = () => {
  //   if (internalRef.current && internalRef.current.controlRef) {
  //     const rect = internalRef.current.controlRef.getBoundingClientRect();
  //     const viewportWidth = window.innerWidth || window.screen?.width || 1024;
  //     const dropdownWidth = props?.optionInnerWidth || 0; // Dropdown's expected width

  //     // Check space on the right and adjust accordingly
  //     if (rect.left + dropdownWidth > viewportWidth) {
  //       setMenuRight(viewportWidth - rect.right - 35);
  //       setMenuLeft(0);
  //     } else {
  //       setMenuLeft(null);
  //       setMenuRight(null);
  //     }
  //   }
  // };

  return (
    <CreatableSelect
      {...restProps}
      inputId={restProps.id}
      menuPlacement="auto"
      minMenuHeight={200}
      // menuPosition="absolute"
      // onMenuOpen={handleMenuOpen}
      isValidNewOption={() => !isNotCreatable}
      formatCreateLabel={(inputValue) =>
        inputValue
          ? `Create "${inputValue}"`
          : props?.createOptionLabel
            ? props.createOptionLabel
            : `Create "new option"`
      }
      onBlur={onBlur ? onBlur : null}
      tabSelectsValue={false}
      placeholder={placeholder ? placeholder : ""}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#ebf2fe", //active
          primary25: "#f1f6fe", //hover
          primary50: "#f1f6fe", //clicable
        },
      })}
      ref={ref}
      onChange={(e) => {
        handleChange(e);
      }}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        ValueContainer: ValueContainer,
        IndicatorSeparator: props?.isIndicatorSeparator
          ? IndicatorSeparator
          : null,
      }}
      options={options}
      styles={selectStyles(error, { ...props })}
      onFocus={(e) => {
        if (isIPad) {
          // e.target.scrollIntoView({ block: "center" });
          setTimeout(() => {
            e.target.scrollIntoView({ block: "nearest", behavior: "smooth" });
          }, 100);
        }
      }}
    />
  );
});

export const CustomAsyncSelect = React.forwardRef<
  SelectInstance<any>,
  AsyncCreatablePropsType
>((props: AsyncCreatablePropsType, ref) => {
  const {
    FieldName,
    handleChange,
    changeValuePerameter,
    onClear,
    isNotCreatable,
    CustomOptionComponent,
    CustomSingleValueComponent,
    placeholder,
    onBlur,
    styles,
    ...restProps
  } = props;

  const methods = useFormContext();
  const error = get(methods?.formState?.errors, FieldName);

  // const [menuLeft, setMenuLeft] = useState<any>(0);
  // const [menuRight, setMenuRight] = useState<any>(0);

  // // Use a local ref to access the Select DOM element
  // const internalRef = React.useRef<any>(null);

  // // Expose the internal ref via the forwarded ref
  // useImperativeHandle(ref, () => internalRef.current);

  // const handleMenuOpen = () => {
  //   if (internalRef.current && internalRef.current.controlRef) {
  //     const rect = internalRef.current.controlRef.getBoundingClientRect();
  //     const viewportWidth = window.innerWidth || window.screen?.width || 1024;
  //     const dropdownWidth = props?.optionInnerWidth || 0; // Dropdown's expected width

  //     // Check space on the right and adjust accordingly
  //     if (rect.left + dropdownWidth > viewportWidth) {
  //       setMenuRight(viewportWidth - rect.right - 35);
  //       setMenuLeft(null);
  //     } else {
  //       setMenuLeft(null);
  //       setMenuRight(null);
  //     }
  //   }
  // };

  const [inputValue, setInputValue] = useState("");

  return (
    <AsyncCreatableSelect
      {...restProps}
      menuPlacement="auto"
      // menuPosition="absolute"
      minMenuHeight={200}
      // onMenuOpen={handleMenuOpen}
      onBlur={onBlur ? onBlur : null}
      inputValue={inputValue}
      // PLEASE DON'T REMOVE THIS
      // onInputChange={(
      //   newValue: string,
      //   actionMeta: { action: string; prevInputValue: string }
      // ) => {
      //   if (props?.isMulti) {
      //     if (actionMeta.action === "input-change") {
      //       setInputValue(newValue);
      //       return newValue; // This ensures the input value persists.
      //     }
      //     return actionMeta?.prevInputValue || newValue || "";
      //   } else {
      //     setInputValue(newValue);
      //     return newValue; // This ensures the input value persists.
      //   }
      // }}
      onInputChange={(
        newValue: string,
        actionMeta: { action: string; prevInputValue: string },
      ) => {
        if (props?.isMulti) {
          if (actionMeta.action === "input-change") {
            setInputValue(newValue);
            return newValue;
          }
          if (
            actionMeta.action === "set-value" ||
            actionMeta.action === "menu-close" ||
            actionMeta.action === "input-blur"
          ) {
            setInputValue("");
            return "";
          }
          return actionMeta?.prevInputValue || newValue || "";
        } else {
          setInputValue(newValue);
          return newValue;
        }
      }}
      inputId={restProps.id}
      blurInputOnSelect={false}
      isValidNewOption={() => !isNotCreatable}
      formatCreateLabel={(inputValue) =>
        inputValue
          ? `Create "${inputValue}"`
          : props?.createOptionLabel
            ? props.createOptionLabel
            : `Create "new option"`
      }
      // filterOption={(option) => {
      //   if ((option as any).__isNew__) return true; // never filter out "create"
      //   return true; // keep all other options too
      // }}
      filterOption={
        props?.filterOption
          ? props.filterOption
          : (option) => {
              if ((option as any).__isNew__) return true; // never filter out "create"
              return true; // default: keep all other options
            }
      }
      placeholder={placeholder ? placeholder : ""}
      cacheOptions
      tabSelectsValue={false}
      ref={ref}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#ebf2fe", //active
          primary25: "#f1f6fe", //hover
          primary50: "#f1f6fe", //clicable
        },
      })}
      onChange={(e) => {
        handleChange(e);
      }}
      styles={mergeStyles(selectStyles(error, { ...props }), styles)}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        ValueContainer: ValueContainer,
        IndicatorSeparator: props?.isIndicatorSeparator
          ? IndicatorSeparator
          : null,
        MenuList: props?.customMenuList || MenuList,
        SingleValue: CustomSingleValueComponent || components.SingleValue,
      }}
      onFocus={(e) => {
        if (isIPad) {
          // e.target.scrollIntoView({ block: "center" });
          // e.target.scrollIntoView({ block: "nearest" });
          setTimeout(() => {
            e.target.scrollIntoView({ block: "nearest", behavior: "smooth" });
          }, 100);
        }
      }}
      // onMenuOpen={() => {
      //   if (isIPad) {
      //     setTimeout(() => {
      //       const inputElement = document.getElementById(restProps.id);
      //       if (inputElement) {
      //         inputElement.scrollIntoView({
      //           block: "center",
      //           behavior: "smooth",
      //         });
      //       }
      //     }, 300);
      //   }
      // }}
    />
  );
});

export const CustomSelectTemp = (props: CreatablePropsType) => {
  const {
    FieldName,
    options,
    handleChange,
    Value,
    changeValuePerameter,
    onClear,
    isNotCreatable,
    CustomOptionComponent,
    placeholder,
    onBlur,
    ...restProps
  } = props;

  let valueChangePerameter = changeValuePerameter ? changeValuePerameter : "";
  const [defaultValue, setDefaultValue] = useState<any>(null);
  const [field, meta, helpers] = useField(`${FieldName}`);

  useEffect((): any => {
    const value = options?.find((item) => item.value === Value);
    if (value) setDefaultValue(value);
    else setDefaultValue(null);
    // return false;
  }, [options, valueChangePerameter, Value]);

  if (!isNotCreatable) {
    return (
      <CreatableSelect
        {...field}
        {...restProps}
        inputId={restProps.id}
        menuPlacement="auto"
        tabSelectsValue
        onBlur={onBlur ? onBlur : null}
        placeholder={placeholder ? placeholder : ""}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#ebf2fe", //active
            primary25: "#f1f6fe", //hover
            primary50: "#f1f6fe", //clicable
          },
        })}
        onChange={(e, ActionType) => {
          if (ActionType.action === "clear") {
            helpers.setValue(null);
            setDefaultValue(null);
            handleChange({ value: null });
            if (props.onClear) {
              onClear();
            }
          } else {
            handleChange(e);
          }
        }}
        components={{
          Option: CustomOptionComponent ? CustomOptionComponent : Option,
          ValueContainer: ValueContainer,
        }}
        options={options}
        value={defaultValue}
        styles={selectStyles(meta, props)}
      />
    );
  } else {
    return (
      <CreatableSelect
        {...field}
        {...restProps}
        inputId={restProps.id}
        onBlur={onBlur ? onBlur : null}
        isValidNewOption={() => false}
        menuPlacement="auto"
        tabSelectsValue
        placeholder={placeholder ? placeholder : ""}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#ebf2fe", //active
            primary25: "#f1f6fe", //hover
            primary50: "#f1f6fe", //clicable
          },
        })}
        onChange={(e, ActionType) => {
          if (ActionType.action === "clear") {
            helpers.setValue(null);
            setDefaultValue(null);
            handleChange({ value: null });
            if (props.onClear) {
              onClear();
            }
          } else {
            handleChange(e);
          }
        }}
        components={{
          Option: CustomOptionComponent ? CustomOptionComponent : Option,
          ValueContainer: ValueContainer,
        }}
        options={options}
        value={defaultValue}
        styles={selectStyles(meta, props)}
      />
    );
  }
};

export const AsyncCustomSelect = (props: AsyncCreatablePropsType) => {
  const {
    FieldName,
    handleChange,
    Value,
    options,
    changeValuePerameter,
    isNotCreatable,
    CustomOptionComponent,
    placeholder,
    onBlur,
    ...restProps
  } = props;

  let valueChangePerameter = changeValuePerameter ? changeValuePerameter : "";
  const [defaultValue, setDefaultValue] = useState<any>(null);
  const [field, meta, helpers] = useField(`${FieldName}`);

  useEffect((): any => {
    const value = options?.find((item) => item.value === Value);
    if (value) setDefaultValue(value);
    else setDefaultValue(null);
    // return false;
  }, [options, valueChangePerameter, Value]);

  if (!isNotCreatable) {
    return (
      <AsyncCreatableSelect
        {...field}
        {...restProps}
        onBlur={onBlur ? onBlur : null}
        inputId={restProps.id}
        menuPlacement="auto"
        placeholder={placeholder ? placeholder : ""}
        cacheOptions
        tabSelectsValue
        options={options}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#ebf2fe", //active
            primary25: "#f1f6fe", //hover
            primary50: "#f1f6fe", //clicable
          },
        })}
        onChange={(e, ActionType) => {
          if (ActionType.action === "clear") {
            if (props.onClear) {
              props.onClear();
            }
            handleChange({ value: null });
            setDefaultValue(null);
            helpers.setValue(null);
          } else {
            handleChange(e);
          }
        }}
        value={defaultValue}
        styles={selectStyles(meta, props)}
        components={{
          Option: CustomOptionComponent ? CustomOptionComponent : Option,
          ValueContainer: ValueContainer,
        }}
      />
    );
  } else {
    return (
      <AsyncCreatableSelect
        {...field}
        menuPlacement="auto"
        {...restProps}
        onBlur={onBlur ? onBlur : null}
        inputId={restProps.id}
        placeholder={placeholder ? placeholder : ""}
        cacheOptions
        tabSelectsValue
        isValidNewOption={() => false}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#ebf2fe", //active
            primary25: "#f1f6fe", //hover
            primary50: "#f1f6fe", //clicable
          },
        })}
        onChange={(e, ActionType) => {
          if (ActionType.action === "clear") {
            if (props.onClear) {
              props.onClear();
            }
            handleChange({ value: null });
            setDefaultValue(null);
            helpers.setValue(null);
          } else {
            handleChange(e);
          }
        }}
        value={defaultValue}
        styles={selectStyles(meta, props)}
        components={{
          Option: CustomOptionComponent ? CustomOptionComponent : Option,
          ValueContainer: ValueContainer,
        }}
      />
    );
  }
};

export const CustomSelectWithoutForm = (props: CreatablePropsType) => {
  const {
    FieldName,
    options,
    handleChange,
    changeValuePerameter,
    onLanguageChange,
    onClear,
    isNotCreatable,
    CustomOptionComponent,
    placeholder,
    onBlur,
    ...restProps
  } = props;

  return (
    <CreatableSelect
      {...restProps}
      inputId={restProps.id}
      menuPlacement="auto"
      minMenuHeight={300}
      // menuPosition="fixed"
      isValidNewOption={() => !isNotCreatable || false}
      formatCreateLabel={(inputValue) =>
        inputValue
          ? `Create "${inputValue}"`
          : props?.createOptionLabel
            ? props.createOptionLabel
            : `Create "new option"`
      }
      filterOption={(option) => {
        if ((option as any).__isNew__) return true; // never filter out "create"
        return true; // keep all other options too
      }}
      tabSelectsValue
      onBlur={onBlur ? onBlur : null}
      placeholder={placeholder ? placeholder : ""}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#ebf2fe", //active
          primary25: "#f1f6fe", //hover
          primary50: "#f1f6fe", //clicable
        },
      })}
      onChange={(e, ActionType) => {
        handleChange(e);
      }}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        ValueContainer: ValueContainer,
      }}
      options={options}
      styles={selectStyles(null, props)}
    />
  );
};

export const SimpleCreatableAsyncSelect = (props: AsyncCreatablePropsType) => {
  const {
    handleChange,
    Value,
    options,
    changeValuePerameter,
    CustomOptionComponent,
    placeholder,
    onBlur,
    ...restProps
  } = props;
  return (
    <AsyncCreatableSelect
      {...restProps}
      onBlur={onBlur ? onBlur : null}
      inputId={restProps.id}
      placeholder={placeholder ? placeholder : ""}
      cacheOptions
      tabSelectsValue
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#ebf2fe", //active
          primary25: "#f1f6fe", //hover
          primary50: "#f1f6fe", //clicable
        },
      })}
      onChange={(e, ActionType) => {
        if (ActionType.action === "clear") {
          if (props.onClear) {
            props.onClear();
          }
          handleChange({ value: null });
        } else {
          handleChange(e);
        }
      }}
      value={Value}
      formatCreateLabel={(inputValue) =>
        inputValue
          ? `Create "${inputValue}"`
          : props?.createOptionLabel
            ? props.createOptionLabel
            : `Create "new option"`
      }
      filterOption={(option) => {
        if ((option as any).__isNew__) return true; // never filter out "create"
        return true; // keep all other options too
      }}
      styles={selectStyles(null, props)}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        ValueContainer: ValueContainer,
      }}
    />
  );
};

export const SimpleAsyncSelect = (props: AsyncCreatablePropsType) => {
  const {
    handleChange,
    changeValuePerameter,
    CustomOptionComponent,
    placeholder,
    onBlur,
    styles,
    ...restProps
  } = props;

  return (
    <AsyncCreatableSelect
      {...restProps}
      menuPlacement="auto"
      minMenuHeight={200}
      maxMenuHeight={250}
      // menuPosition="fixed"
      onBlur={onBlur ? onBlur : null}
      inputId={restProps.id}
      placeholder={placeholder ? placeholder : ""}
      isValidNewOption={() => !props?.isNotCreatable || false}
      formatCreateLabel={(inputValue) =>
        inputValue
          ? `Create "${inputValue}"`
          : props?.createOptionLabel
            ? props.createOptionLabel
            : `Create "new option"`
      }
      filterOption={(option) => {
        if ((option as any).__isNew__) return true; // never filter out "create"
        return true; // keep all other options too
      }}
      cacheOptions
      tabSelectsValue
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#ebf2fe", //active
          primary25: "#f1f6fe", //hover
          primary50: "#f1f6fe", //clicable
        },
      })}
      onChange={(e, ActionType) => {
        handleChange(e);
      }}
      styles={mergeStyles(selectStyles(null, props), styles)}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        MenuList: props?.customMenuList || MenuList,
        ValueContainer: ValueContainer,
      }}
      onFocus={(e) => {
        if (isIPad) {
          // e.target.scrollIntoView({ block: "center" });
          setTimeout(() => {
            e.target.scrollIntoView({ block: "nearest", behavior: "smooth" });
          }, 100);
        }
      }}
    />
  );
};

export const SimpleSelect = (props: CreatablePropsType) => {
  const {
    handleChange,
    changeValuePerameter,
    CustomOptionComponent,
    placeholder,
    onBlur,
    ...restProps
  } = props;
  return (
    <CreatableSelect
      {...restProps}
      onBlur={onBlur ? onBlur : null}
      inputId={restProps.id}
      placeholder={placeholder ? placeholder : ""}
      isValidNewOption={() => !props?.isNotCreatable || false}
      formatCreateLabel={(inputValue) =>
        inputValue
          ? `Create "${inputValue}"`
          : props?.createOptionLabel
            ? props.createOptionLabel
            : `Create "new option"`
      }
      filterOption={(option, inputValue) => {
        if ((option as any).__isNew__) return true; // never filter out "create"
        if (!inputValue) return true; // keep all other options too
        return option.label?.toLowerCase().includes(inputValue.toLowerCase());
      }}
      tabSelectsValue
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#ebf2fe", //active
          primary25: "#f1f6fe", //hover
          primary50: "#f1f6fe", //clicable
        },
      })}
      onChange={(e, ActionType) => {
        handleChange(e);
      }}
      styles={selectStyles(null, props)}
      components={{
        Option: CustomOptionComponent ? CustomOptionComponent : Option,
        ValueContainer: ValueContainer,
      }}
    />
  );
};

const mergeStyles = (defaultStyles: any, customStyles: any): any => {
  if (!customStyles) return defaultStyles;

  const merged: any = { ...defaultStyles };
  Object.keys(customStyles).forEach((key) => {
    if (
      typeof customStyles[key] === "function" &&
      typeof defaultStyles[key] === "function"
    ) {
      merged[key] = (base: any, state: any) => ({
        ...defaultStyles[key](base, state),
        ...customStyles[key](base, state),
      });
    } else {
      merged[key] = customStyles[key];
    }
  });
  return merged;
};

const isDarkTheme = () =>
  typeof document !== "undefined" &&
  document.documentElement.getAttribute("data-theme") === "dark";

/** Original light-mode select styles — do not change. */
const lightSelectStyles = (error: any, props: any): any => {
  return {
    control: (basestyle: CSSObjectWithLabel, state: any) => ({
      ...basestyle,
      minHeight: "40px",
      backgroundColor: props.isDisabled ? "#e1e1e1" : "#FAFBFD",
      border: props.isBorderNone
        ? "none"
        : error
          ? state.isFocused
            ? "1px solid #d32f2f"
            : "1px solid #d32f2f"
          : state.isFocused
            ? "1px solid  #2e67a3"
            : "1px solid #e0e0e0",
      borderRadius: "8px",
      boxShadow: props.isBorderNone ? "none" : basestyle.boxShadow,
      "&:hover": {
        border: props.isBorderNone
          ? "none"
          : error
            ? "1px solid #d32f2f"
            : "1px solid #2e67a3",
      },
    }),
    placeholder: (basestyle: CSSObjectWithLabel, state: any) => {
      if (!props.isPlaceholderFloating) {
        return {
          ...basestyle,
          color: error
            ? "#d32f2f"
            : state.hasValue || state.selectProps.inputValue
              ? state.isFocused
                ? "#0b0b45"
                : "gray"
              : "gray",
        };
      } else
        return {
          ...basestyle,
          color: error
            ? "#d32f2f"
            : state.hasValue || state.selectProps.inputValue
              ? state.isFocused
                ? "#0b0b45"
                : "gray"
              : "gray",
          overflow: "hidden",
          backgroundColor:
            state.hasValue || state.selectProps.inputValue
              ? "white"
              : "transparant",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          position:
            state.hasValue || state.selectProps.inputValue
              ? "absolute"
              : "static",
          top: state.hasValue || state.selectProps.inputValue ? -15 : "10%",
          transition: "top 0.3s, font-size 0.1s",
          fontSize: (state.hasValue || state.selectProps.inputValue) && 10,
          paddingLeft:
            state.hasValue || state.selectProps.inputValue ? "3px" : "0px",
          paddingRight:
            state.hasValue || state.selectProps.inputValue ? "3px" : "0px",
        };
    },
    option: (basestyle: CSSObjectWithLabel, state: any) => {
      return {
        ...basestyle,
        color: state.isSelected ? "black" : "black",
        border: "1px solid #f1f6fe",
        backgroundColor: state.data?.__isNew__
          ? "#e1eaf1"
          : state.isFocused
            ? "#f1f6fe"
            : "white",
      };
    },
    valueContainer: (provided: CSSObjectWithLabel, state: any) => ({
      ...provided,
      overflow:
        state.hasValue || state.selectProps.inputValue ? "visible" : "hidden",
    }),
    dropdownIndicator: (base: CSSObjectWithLabel, state: any) => ({
      ...base,
      color: error ? "#d32f2f" : "#adb5bd",
      "&:hover": {
        color: error ? "#d32f2f" : "black",
      },
    }),
    menu: (base: CSSObjectWithLabel, state: any) => {
      return {
        ...base,
        width: props?.optionInnerWidth || "100% !important",
      };
    },
    indicatorSeparator: (base: CSSObjectWithLabel, state: any) => ({
      ...base,
      backgroundColor: error ? "#d32f2f" : "#adb5bd",
    }),
    clearIndicator: (base: CSSObjectWithLabel, state: any) => ({
      ...base,
      color: error ? "#d32f2f" : "#adb5bd",
      "&:hover": {
        color: error ? "#d32f2f" : "black",
      },
    }),
    menuPortal: (base: CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }),
  };
};

const darkSelectStyles = (error: any, props: any): any => {
  const controlBg = props.isDisabled ? "#3a3a3e" : "#252528";
  const borderIdle = "#3a3a3e";
  const borderFocus = error ? "#d32f2f" : "#2e67a3";
  const textColor = "#f5f5f5";
  const placeholderColor = error ? "#d32f2f" : "#9a9a9a";

  return {
    control: (basestyle: CSSObjectWithLabel, state: any) => ({
      ...basestyle,
      minHeight: "40px",
      backgroundColor: controlBg,
      color: textColor,
      border: props.isBorderNone
        ? "none"
        : error
          ? `1px solid ${borderFocus}`
          : state.isFocused
            ? `1px solid ${borderFocus}`
            : `1px solid ${borderIdle}`,
      borderRadius: "8px",
      boxShadow: props.isBorderNone ? "none" : basestyle.boxShadow,
      "&:hover": {
        border: props.isBorderNone
          ? "none"
          : error
            ? "1px solid #d32f2f"
            : `1px solid ${borderFocus}`,
      },
    }),
    singleValue: (basestyle: CSSObjectWithLabel) => ({
      ...basestyle,
      color: textColor,
    }),
    multiValue: (basestyle: CSSObjectWithLabel) => ({
      ...basestyle,
      backgroundColor: "#3a3a3e",
    }),
    multiValueLabel: (basestyle: CSSObjectWithLabel) => ({
      ...basestyle,
      color: textColor,
    }),
    input: (basestyle: CSSObjectWithLabel) => ({
      ...basestyle,
      color: textColor,
    }),
    placeholder: (basestyle: CSSObjectWithLabel, state: any) => {
      if (!props.isPlaceholderFloating) {
        return { ...basestyle, color: placeholderColor };
      }
      return {
        ...basestyle,
        color: placeholderColor,
        overflow: "hidden",
        backgroundColor:
          state.hasValue || state.selectProps.inputValue
            ? "#252528"
            : "transparent",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        position:
          state.hasValue || state.selectProps.inputValue
            ? "absolute"
            : "static",
        top: state.hasValue || state.selectProps.inputValue ? -15 : "10%",
        transition: "top 0.3s, font-size 0.1s",
        fontSize: (state.hasValue || state.selectProps.inputValue) && 10,
        paddingLeft:
          state.hasValue || state.selectProps.inputValue ? "3px" : "0px",
        paddingRight:
          state.hasValue || state.selectProps.inputValue ? "3px" : "0px",
      };
    },
    option: (basestyle: CSSObjectWithLabel, state: any) => ({
      ...basestyle,
      color: textColor,
      border: "1px solid #2e2e32",
      backgroundColor: state.data?.__isNew__
        ? "#1e2a3a"
        : state.isFocused
          ? "#2a2a2e"
          : "#1c1c1e",
    }),
    menu: (base: CSSObjectWithLabel) => ({
      ...base,
      width: props?.optionInnerWidth || "100% !important",
      backgroundColor: "#1c1c1e",
      color: textColor,
    }),
    menuList: (base: CSSObjectWithLabel) => ({
      ...base,
      backgroundColor: "#1c1c1e",
    }),
    valueContainer: (provided: CSSObjectWithLabel, state: any) => ({
      ...provided,
      overflow:
        state.hasValue || state.selectProps.inputValue ? "visible" : "hidden",
    }),
    dropdownIndicator: (base: CSSObjectWithLabel) => ({
      ...base,
      color: error ? "#d32f2f" : "#adb5bd",
      "&:hover": {
        color: error ? "#d32f2f" : "#f5f5f5",
      },
    }),
    indicatorSeparator: (base: CSSObjectWithLabel) => ({
      ...base,
      backgroundColor: error ? "#d32f2f" : "#adb5bd",
    }),
    clearIndicator: (base: CSSObjectWithLabel) => ({
      ...base,
      color: error ? "#d32f2f" : "#adb5bd",
      "&:hover": {
        color: error ? "#d32f2f" : "#f5f5f5",
      },
    }),
    menuPortal: (base: CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }),
  };
};

const selectStyles = (error: any, props: any): any =>
  isDarkTheme()
    ? darkSelectStyles(error, props)
    : lightSelectStyles(error, props);
